<template>
    <div class="sticker-focus" ref="focus">
        <div class="sticker-focus-box" :style="size && { width: `${size.w * scale}px`, height: `${size.h * scale}px` }">
            <div class="sticker-focus-content" ref="content" :style="{ transform: `scale(${scale})`, maxWidth: maxWidth ? `${maxWidth}px` : null }" @load.capture="updateScale">
                <component
                    :is="wrapper"
                    :sticker="readonlySticker"
                    :isPreventCover="false"
                    :isCover="false"
                    :setCover="noop"
                    :setCbClick="noop"
                    :files="files"
                    :backgroundFileId="backgroundFileId"
                    :pageSelected="pageSelected"
                    :previewEnabled="true"
                />
            </div>
        </div>
        <ul v-if="productNames.length > 1" class="sticker-focus-products">
            <li v-for="(name, index) in productNames" :key="index">{{ name }}</li>
        </ul>
    </div>
</template>

<script>
    // Copie lecture seule d'un sticker, centrée et agrandie (aucun listener : les emits sont ignorés)
    export default {
        props: {
            sticker: Object,
            wrapper: [Object, Function],
            files: Object,
            pageSelected: Object,
            backgroundFileId: [String, Number],
        },

        data() {
            return {
                scale: 1,
                size: null,
                maxWidth: null,
            }
        },

        mounted() {
            // même largeur max que dans la story (.story-maker-draggable-sticker.text : 80%)
            this.maxWidth = this.$refs.focus.offsetWidth * 0.8;
            this.updateScale();
        },

        methods: {
            noop() {},

            updateScale() {
                this.$nextTick(() => {
                    const { focus, content } = this.$refs;
                    if (!focus || !content || !content.offsetWidth || !content.offsetHeight) return;
                    this.size = { w: content.offsetWidth, h: content.offsetHeight };
                    this.scale = Math.min(
                        (focus.offsetWidth * 0.85) / this.size.w,
                        (focus.offsetHeight * (this.productNames.length > 1 ? 0.55 : 0.7)) / this.size.h,
                        3
                    );
                });
            },
        },

        computed: {
            readonlySticker() {
                return {
                    ...JSON.parse(JSON.stringify(this.sticker)),
                    isEditing: false,
                    position: { x: 50, y: 50 },
                    transform: { rotate: 0, scale: 1 },
                };
            },

            productNames() {
                const products = this.sticker.type === 'product' && this.sticker.data && this.sticker.data.products;
                return Array.isArray(products) ? products.map(p => p.text).filter(Boolean) : [];
            },
        },

        watch: {
            sticker() {
                this.scale = 1;
                this.size = null;
                this.updateScale();
            },
        },
    }
</script>
